import { api, multipartApi } from './networkService';

class PageService {
    static async fetch(page, filters) {
        try {
            const response = await api.get(`api/user/page`, {
                params: {
                    page: page,
                    perPage: 20,
                    ...filters
                }
            });
            return response.data;
        } catch (error) {
            console.error('Fetch page error:', error);
            throw error;
        }
    }

    static async fetchAll(filters) {
        try {
            const response = await api.get(`api/user/page`, {
                params: filters
            });
            return response.data;
        } catch (error) {
            console.error('Fetch page error:', error);
            throw error;
        }
    }

    static async fetchAllWithCitiesDropdown() {
        try {
            const response = await api.get(`api/user/page/all/cities`);
            return response.data;
        } catch (error) {
            console.error('Fetch page error:', error);
            throw error;
        }
    }

    static async fetchAllWithCities(page, filters) {
        try {
            const response = await api.get(`api/user/page/all/cities`, {
                params: {
                    page: page,
                    perPage: 20,
                    ...filters
                }
            });
            return response.data;
        } catch (error) {
            console.error('Fetch page error:', error);
            throw error;
        }
    }

    static async fetchOne(id) {
        try {
            const response = await api.get(`api/user/page/${id}`);
            return response.data;
        } catch (error) {
            console.error('Fetch page error:', error);
            throw error;
        }
    }

    static async add(page) {
        try {
            const response = await multipartApi.post(`api/user/page`, page);
            return response;
        } catch (error) {
            console.error('Add page error:', error);
            throw error;
        }
    }

    static async update(id, page) {
        try {
            const response = await multipartApi.put(`api/user/page/${id}`, page);
            return response;
        } catch (error) {
            console.error('Update page error:', error);
            throw error;
        }
    }

    static async delete(id) {
        try {
            const response = await api.delete(`api/user/page/${id}`);
            return response;
        } catch (error) {
            console.error('Delete page error:', error);
            throw error;
        }
    }
}

export default PageService;
